export class RootField {
    getKey() {
        return `root`;
    }
    getValue(values) {
        return values;
    }
    setValue(value, _values) {
        return value;
    }
}
export function createRoot() {
    return new RootField();
}
export class DefaultField {
    defaultValue;
    field;
    constructor(defaultValue, field) {
        this.defaultValue = defaultValue;
        this.field = field;
    }
    getKey() {
        return this.field.getKey();
    }
    getValue(values) {
        const value = this.field.getValue(values);
        return value == null ? this.defaultValue : value;
    }
    setValue(value, values) {
        return this.field.setValue(value, values);
    }
}
export function createDefault(defaultValue, field) {
    return new DefaultField(defaultValue, field);
}
export class PropertyField {
    self;
    property;
    constructor(self, property) {
        this.self = self;
        this.property = property;
    }
    getKey() {
        return `${this.self.getKey()}.${this.property}`;
    }
    getValue(values) {
        return this.self.getValue(values)[this.property];
    }
    setValue(value, values) {
        let object = this.self.getValue(values);
        object = { ...object, [this.property]: value };
        return this.self.setValue(object, values);
    }
}
export function createProperty(self, property) {
    return new PropertyField(self, property);
}
export class ListItemField {
    self;
    index;
    defaultItem;
    constructor(self, index, defaultItem) {
        this.self = self;
        this.index = index;
        this.defaultItem = defaultItem;
    }
    getKey() {
        return `${this.self.getKey()}[${this.index}]`;
    }
    getValue(values) {
        const list = this.self.getValue(values);
        const item = list[this.index];
        return item == undefined ? this.defaultItem : item;
    }
    setValue(value, values) {
        const list = [...this.self.getValue(values)];
        list[this.index] = value;
        return this.self.setValue(list, values);
    }
}
export function createListItem(index, self, defaultItem) {
    return new ListItemField(self, index, defaultItem);
}
export function createProperties(self, properties) {
    const res = {};
    for (const property of properties) {
        res[property] = createProperty(self, property);
    }
    return res;
}
